import React from 'react';
import {
  HydrationBoundary, QueryCache, QueryClient, QueryClientProvider
} from '@tanstack/react-query';

import Logger from 'common/Logger';
import { CONFIG } from 'constants/config';

import type { QueryClientConfig } from '@tanstack/react-query';

interface Props {
  state: any,
  children?: React.ReactNode
}

const config: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !CONFIG.DISABLE_REFETCH_ON_FOCUS,
      staleTime: CONFIG.DURATIONS.DEFAULT_QUERY_STALE_TIME
    }
  },
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      Logger.error(`Failed to fetch query ${query.queryKey[0]}`, { key: query.queryKey, message: error?.message });
    }
  })
};

const QueryProvider = (props: Props) => {
  const { state, children } = props;
  const [queryClient] = React.useState(() => new QueryClient(config));
  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={state}>
        {children}
      </HydrationBoundary>
    </QueryClientProvider>
  );
};

export default QueryProvider;
